module.exports = __webpack_public_path__ + "static/media/trofeus (2).c66426ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (2).jpg
// module id = 366
// module chunks = 0